// extracted by mini-css-extract-plugin
export var caption = "image-module--caption--5uO6X";
export var sbShowMain = "image-module--sb-show-main--0SX-i";
export var svgIcon = "image-module--svgIcon--P3V07";